import React, { useEffect, useState } from 'react';
import { Container, Tab, Tabs } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/App.css';
import './styles/markdown.css';

// Components
import Header from './components/Header';
import ChatTab from './components/ChatTab';
import SearchTab from './components/SearchTab';
import ManagePDFsTab from './components/ManagePDFsTab';
import ModelConfigTab from './components/ModelConfigTab';
import KnowledgeGraphTab from './components/KnowledgeGraphTab';
import DataDashboardTab from './components/DataDashboardTab';
import UIControlsTab from './components/UIControlsTab';
import CampusAffiliationModal from './components/CampusAffiliationModal';

// Context
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { CampusProvider } from './contexts/CampusContext';

const ADMIN_TAB_KEYS = ['knowledge-graph', 'dashboard', 'manage', 'ui-controls', 'config'];

function AppTabs() {
  const [activeTab, setActiveTab] = useState('chat');
  const { isAdmin, loading } = useAuth();

  useEffect(() => {
    if (!loading && !isAdmin && ADMIN_TAB_KEYS.includes(activeTab)) {
      setActiveTab('chat');
    }
  }, [activeTab, isAdmin, loading]);

  // Wrap admin-only tab content.
  const adminContent = (children) => {
    if (loading) return <div className="tab-content" />;
    return <div className="tab-content">{children}</div>;
  };

  return (
    <Container fluid className="main-container">
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k || 'chat')}
        className="nav-tabs"
      >
        <Tab eventKey="chat" title={<><i className="fas fa-comments me-2"></i>Chat</>}>
          <div className="tab-content chat-tab-shell">
            <ChatTab />
          </div>
        </Tab>

        <Tab eventKey="search" title={<><i className="fas fa-search me-2"></i>Search PDFs</>}>
          <div className="tab-content">
            <SearchTab />
          </div>
        </Tab>

        {isAdmin && (
          <Tab
            eventKey="knowledge-graph"
            title={<><i className={`fas fa-project-diagram me-2`}></i>Knowledge Graph</>}
          >
            {adminContent(<KnowledgeGraphTab />)}
          </Tab>
        )}

        {isAdmin && (
          <Tab
            eventKey="dashboard"
            title={<><i className="fas fa-chart-pie me-2"></i>Data Dashboard</>}
          >
            {adminContent(<DataDashboardTab />)}
          </Tab>
        )}

        {isAdmin && (
          <Tab
            eventKey="manage"
            title={<><i className="fas fa-file-pdf me-2"></i>Manage PDFs</>}
          >
            {adminContent(<ManagePDFsTab />)}
          </Tab>
        )}

        {isAdmin && (
          <Tab eventKey="ui-controls" title={<><i className="fas fa-sliders-h me-2"></i>UI Controls</>}>
            {adminContent(<UIControlsTab />)}
          </Tab>
        )}

        {isAdmin && (
          <Tab
            eventKey="config"
            title={<><i className="fas fa-cog me-2"></i>Model Config</>}
          >
            {adminContent(<ModelConfigTab />)}
          </Tab>
        )}
      </Tabs>
    </Container>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <CampusProvider>
          <div className="App">
            <Header />
            <AppTabs />
            <CampusAffiliationModal />
          </div>
        </CampusProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
